import { AppDefinition } from '../../types/apps';

export const SequenceBuilderAppDefinition: AppDefinition = {
  appId: 'sequences',
  name: 'Sequence Builder',
  version: '1.0.0',
  description:
    'Build cold-email campaigns end-to-end: source leads from Apollo, generate personalized sequences, ' +
    'and launch them via Instantly in one flow.',

  icon: {
    type: 'phosphor',
    phosphorIcon: 'PaperPlaneTilt',
    phosphorWeight: 'duotone',
    color: '#3b82f6',
    metadata: { source: 'app', appId: 'sequences', isAppIcon: true },
  },

  entityIcons: {
    OutboundCampaign: {
      type: 'phosphor',
      phosphorIcon: 'PaperPlaneTilt',
      phosphorWeight: 'duotone',
      color: '#3b82f6',
    },
  },

  entityTypes: ['OutboundCampaign'],

  searchableSkeletonFields: {
    OutboundCampaign: ['persona', 'product', 'painPoint', 'preset'],
  },

  component: 'SequenceBuilderApp',
  requiresProps: false,
  requiresEntity: false,

  agenticToolIds: [],
  features: [],
  actions: {},
};
